import { Goal } from '@/context/UserDataContext';
import { 
  Heart, Zap, Brain, Smile, Moon, Shield, Dumbbell,
  BatteryCharging, HeartPulse, Bone, Eye, FlaskConical, 
  Activity, Stethoscope, Clock
} from 'lucide-react';
import React from 'react';

export const goalIcons: Record<Goal, React.ReactNode> = {
  'general_wellbeing': <Heart className="h-3.5 w-3.5" />,
  'energy': <Zap className="h-3.5 w-3.5" />,
  'mental_clarity': <Brain className="h-3.5 w-3.5" />,
  'mood': <Smile className="h-3.5 w-3.5" />,
  'sleep': <Moon className="h-3.5 w-3.5" />,
  'immune_support': <Shield className="h-3.5 w-3.5" />,
  'fitness': <Dumbbell className="h-3.5 w-3.5" />
};

export const goalLabels: Record<Goal, string> = {
  'general_wellbeing': 'General Wellbeing',
  'energy': 'Energy',
  'mental_clarity': 'Mental Clarity',
  'mood': 'Mood',
  'sleep': 'Sleep',
  'immune_support': 'Immune Support',
  'fitness': 'Fitness'
};

interface BenefitIconInfo {
  icon: React.ReactNode;
  className: string;
}

export const getBenefitIcon = (benefit: string): BenefitIconInfo => {
  const lowerBenefit = benefit.toLowerCase();
  
  if (lowerBenefit.includes('brain') || lowerBenefit.includes('cognit') || lowerBenefit.includes('memory') || lowerBenefit.includes('focus')) {
    return { icon: <Brain className="h-3.5 w-3.5 text-indigo-500" />, className: "text-indigo-500" };
  } else if (lowerBenefit.includes('energy') || lowerBenefit.includes('fatigue')) {
    return { icon: <BatteryCharging className="h-3.5 w-3.5 text-yellow-500" />, className: "text-yellow-500" };
  } else if (lowerBenefit.includes('muscle') || lowerBenefit.includes('strength') || lowerBenefit.includes('workout')) {
    return { icon: <Dumbbell className="h-3.5 w-3.5 text-blue-500" />, className: "text-blue-500" };
  } else if (lowerBenefit.includes('heart') || lowerBenefit.includes('cardio') || lowerBenefit.includes('blood pressure')) {
    return { icon: <HeartPulse className="h-3.5 w-3.5 text-rose-500" />, className: "text-rose-500" };
  } else if (lowerBenefit.includes('immune') || lowerBenefit.includes('defense')) {
    return { icon: <Shield className="h-3.5 w-3.5 text-emerald-500" />, className: "text-emerald-500" };
  } else if (lowerBenefit.includes('sleep') || lowerBenefit.includes('insomnia') || lowerBenefit.includes('rest')) {
    return { icon: <Moon className="h-3.5 w-3.5 text-purple-500" />, className: "text-purple-500" };
  } else if (lowerBenefit.includes('mood') || lowerBenefit.includes('depression') || lowerBenefit.includes('anxiety')) {
    return { icon: <Smile className="h-3.5 w-3.5 text-amber-500" />, className: "text-amber-500" };
  } else if (lowerBenefit.includes('bone') || lowerBenefit.includes('joint')) {
    return { icon: <Bone className="h-3.5 w-3.5 text-stone-500" />, className: "text-stone-500" };
  } else if (lowerBenefit.includes('vision') || lowerBenefit.includes('eye')) {
    return { icon: <Eye className="h-3.5 w-3.5 text-cyan-500" />, className: "text-cyan-500" };
  } else if (lowerBenefit.includes('antioxidant') || lowerBenefit.includes('radical')) {
    return { icon: <FlaskConical className="h-3.5 w-3.5 text-green-500" />, className: "text-green-500" };
  } else if (lowerBenefit.includes('digestion') || lowerBenefit.includes('gut') || lowerBenefit.includes('intestin')) {
    return { icon: <Activity className="h-3.5 w-3.5 text-orange-500" />, className: "text-orange-500" };
  } else if (lowerBenefit.includes('general') || lowerBenefit.includes('health') || lowerBenefit.includes('wellbeing')) {
    return { icon: <Stethoscope className="h-3.5 w-3.5 text-teal-500" />, className: "text-teal-500" };
  } else {
    return { icon: <Clock className="h-3.5 w-3.5 text-slate-500" />, className: "text-slate-500" };
  }
}; 